import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getTradePendingDetailsRequest } from "src/store/actions/tradeIn";
import { Status } from "src/store/reducers/tradeIn";
import { ApplicationStore } from "Types/state";
import { selectQuestion } from "../../lib";
import "./OptionSelectionTool.scss";

interface AdditionalProps {
    onFocus: (e: React.FocusEvent<HTMLSelectElement>) => void;
}

const OptionSelectionTool = ({
    status,
    uuid,
    year,
    make,
    model,
    trim,
    choices,
    question,
    answers,
    partner_id,
    getTradePendingDetails,
    onFocus,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & AdditionalProps) => {
    const { t } = useTranslation();

    const handleChange = (event: any) => {
        getTradePendingDetails(
            { year, make, model, trim, partner_id, answers: { ...answers, [question as string]: event.target.value } },
            uuid
        );
    };

    const handleFocus = (event: React.FocusEvent<HTMLSelectElement>) => {
        if (Object.keys(answers).length > 0) {
            onFocus(event);
        }
    };

    return (
        <div className="SelectionTool__container">
            <div className="SelectionTool__body--header">
                {t("TradePending.OptionSelectionTool.header", { make, model, trim, year })}
            </div>

            {Object.keys(answers).length > 0 && (
                <div className="SelectionTool__body--answered">
                    {Object.keys(answers).map((key) => {
                        return (
                            <div className="SelectionTool__container--answer" key={key}>
                                <span className="SelectionTool__answer--question">{selectQuestion(key)}</span>
                                <select className="SelectionTool__answer--select" disabled>
                                    <option className="SelectionTool__select--option" key={0} value={answers[key]}>
                                        {answers[key]}
                                    </option>
                                </select>
                            </div>
                        );
                    })}
                </div>
            )}

            {question && choices.length > 0 && (
                <div className="SelectionTool__body--select" data-e2e="selectionToolSelectRoot">
                    <div className="SelectionTool__container--select">
                        <span className="SelectionTool__select--question">{selectQuestion(question)}</span>

                        <div className="SelectionTool__select--container" data-e2e="selectionToolSelectContainer">
                            <select
                                className="SelectionTool__select"
                                key={question}
                                placeholder={t("TradePending.OptionSelectionTool.OptionSelect.placeholder")}
                                onChange={handleChange}
                                onFocus={handleFocus}
                                disabled={status === Status.Loading}
                                defaultValue={""}
                                required={true}
                            >
                                <option
                                    className="SelectionTool__select--option"
                                    key={"placeholder"}
                                    value={""}
                                    disabled={true}
                                >
                                    {t("TradePending.OptionSelectionTool.OptionSelect.placeholder")}
                                </option>
                                {choices.map((choice: string, index: number) => (
                                    <option className="SelectionTool__select--option" key={index} value={choice}>
                                        {choice}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore) => {
    return {
        status: state.tradeIn.status,
        uuid: state.deal.uuid as string,
        make: state.tradeIn.make,
        model: state.tradeIn.model,
        trim: state.tradeIn.trim,
        year: state.tradeIn.year,
        choices: state.tradeIn.choices,
        question: state.tradeIn.question,
        answers: state.tradeIn.answers,
        partner_id: state.account?.integration_settings?.TP_TradeEstimate.partner_id as string,
    };
};

const mapDispatchToProps = {
    getTradePendingDetails: getTradePendingDetailsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionSelectionTool);
